import {PagewebErrorType} from './PagewebErrorType.enum';

export const ERROR_STATE_NAME = 'errors';

export const SHOW_NETWORK_ERROR_LIST = [
  PagewebErrorType.NetworkStatusError,
  PagewebErrorType.UnexpectedFetchError,
  PagewebErrorType.ApolloError,
];
